import React from "react";
export const ShareContext = React.createContext({});
export const ShareProvider = ShareContext.Provider;

export const ShareContainer = (props) => {
	return <ShareProvider value={props.value}>{props.children}</ShareProvider>;
};
